import React from "react";

interface InputFieldProps {
  label: string;
  value: string;
  setValue: (value: string) => void;
  type?: string;
  placeholder?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  value,
  setValue,
  type = "text",
  placeholder,
}) => (
  <div>
    <label className="block font-medium text-gray-700 mb-2">{label}</label>
    <input
      type={type}
      value={value ?? ""}
      onChange={(e) => setValue(e.target.value)}
      className="w-full border mb-2 border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
      placeholder={placeholder}
    />
  </div>
);

export default InputField;
